import { type FC } from 'react';
import { type OrderMetadata } from '@/screens/order-inbounds/types';
import { OriginalInboundMessageHeader } from '@/screens/order-inbounds/original-inbound-message-header';
import { OriginalInboundVoicemail } from '@/screens/order-inbounds/original-inbound-voicemail';
import { SCREEN_PADDING_SMALL } from '@/styles';
import { StyleSheet, View } from 'react-native';

interface Props {
  isSummaryView?: boolean;
  onSelect?: (searchInputUUID: string) => void;
  order: OrderMetadata;
  selectedInputUUID?: string;
  showTranslation?: boolean;
  translationToggle?: React.ReactNode;
}

export const OrderInboundsDetailVoicemailContent: FC<Props> = ({
  isSummaryView,
  onSelect,
  order,
  selectedInputUUID,
  showTranslation,
  translationToggle,
}) => {
  return (
    <View style={styles.container}>
      <OriginalInboundMessageHeader
        isSummaryView={isSummaryView}
        order={order}
        showTranslation={showTranslation}
      />
      <OriginalInboundVoicemail
        messageHeader={translationToggle}
        onSelect={onSelect}
        order={order}
        selectedInputUUID={selectedInputUUID}
        showTranslation={showTranslation}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    gap: SCREEN_PADDING_SMALL,
  },
});
